import { enhanceTextarea, } from '@tencent/exeditor3-ui-kit/dist/textarea.js';
export function createTextarea(config) {
    const textarea = enhanceTextarea(document.createElement('textarea'));
    textarea.className = 'title';
    textarea.placeholder = config.placeholder || '';
    textarea.draggable = false;
    textarea.addEventListener('change', () => {
        var _a;
        (_a = config.onChange) === null || _a === void 0 ? void 0 : _a.call(config, textarea.value);
    });
    textarea.addEventListener('keydown', (event) => {
        const { key } = event;
        if (key === 'Enter') {
            event.preventDefault();
        }
    });
    textarea.addEventListener('input', () => {
        if (textarea.value.includes('\n')) {
            textarea.value = textarea.value.replace(/\n/g, ' ');
            textarea.resize();
        }
    });
    return textarea;
}
//# sourceMappingURL=helper.js.map